<div class="edit-path-user-modal modal-content">
  <button
    type="button"
    class="modal-close-button"
    (click)="close()"
    aria-label="Luk"
  >
    &times;
  </button>
  <h2 class="modal-title">Rediger bruger</h2>
  <div class="modal-body">
    <form (ngSubmit)="submit()">
      <div class="form-group">
        <label for="full_name">Bruger</label>
        <input
          id="full_name"
          type="text"
          class="form-control"
          [(ngModel)]="full_name"
          name="full_name"
          readonly
        />
      </div>
      <div class="form-group">
        <label for="requirement_started_at"
          >Start dato for uddannelsesvej</label
        >
        <input
          id="requirement_started_at"
          type="date"
          class="form-control"
          [(ngModel)]="requirement_started_at"
          name="requirement_started_at"
        />
      </div>
      <div class="form-group">
        <label for="maintenance_started_at"
          >Start dato for vedligeholdelse</label
        >
        <input
          id="maintenance_started_at"
          type="date"
          class="form-control"
          [(ngModel)]="maintenance_started_at"
          name="maintenance_started_at"
        />
      </div>
      @if (!loadingVersions) {
      <div class="form-group">
        <label for="version_id">Version</label>
        <select
          id="version_id"
          class="form-control"
          [(ngModel)]="version_id"
          name="version_id"
          [disabled]="removeUser"
        >
          <option [ngValue]="null">Vælg version</option>
          @for (v of versions; track v) {
          <option [ngValue]="v.version_id">{{ v.name }}</option>
          }
        </select>
      </div>
      } @if (loadingVersions) {
      <div class="form-group">
        <span class="loading-text">Henter versioner...</span>
      </div>
      }
      <div class="form-group checkbox-group">
        <label>
          <input type="checkbox" [(ngModel)]="removeUser" name="removeUser" />
          Fjern bruger fra uddannelsesvej
        </label>
        <p class="field-hint">
          Kryds af for at fjerne brugeren fra denne uddannelsesvej. Gem derefter
          for at bekræfte.
        </p>
      </div>
      @if (error) {
      <p class="error-message">{{ error }}</p>
      }
      <div class="modal-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="close()"
          [disabled]="submitting"
        >
          Annuller
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="submitting">
          {{ submitting ? "Gemmer..." : "Gem" }}
        </button>
      </div>
    </form>
  </div>
</div>
